/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/
import {connect} from './src/Global';
import {Level} from './metrics/Level';
import Metric from './metrics/Metric';
import Metrics from './metrics/Metrics';

/**
 * Defines the metrics API.
 */
export interface MetricsApi {
  /**
   * Creates a metrics instance for the specified component to log entries and events.
   * @param name The name of the component.
   */
  create(name: string): Readonly<Metrics>;
}

const api = connect('metrics', [
  ['create', true]
]);

export default api;
export {
  Level,
  Metric,
  Metrics
};
